<template>
  <fb-form-properties-manager :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "MultipleChoiceV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "textInput",
          properties: {
            label: "Label"
          },
          property: "label"
        },
        {
          type: "multipleText",
          properties: {
            label: "Options",
            allowCollections: true
          },
          property: "options"
        },
        {
          type: "textInput",
          properties: {
            label: "Description"
          },
          property: "description"
        },
        {
          type: "checkbox",
          properties: {
            label: "Required",
            disabled: element => {
              return !(element.properties.hidden == false || element.properties.hidden == "{{!(true)}}");
            }
          },
          property: "required"
        },
        {
          type: "checkbox",
          properties: {
            label: "Show inline"
          },
          property: "showInline"
        },
        {
          type: "textInput",
          properties: {
            label: "Columns Count",
            type: "number"
          },
          property: "columnsCount"
        },
        {
          type: "checkbox",
          properties: {
            label: "Editable in Patient Portal"
          },
          property: "eFormEditable"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>
